import { Outlet } from '@tanstack/react-router';
import { Moon, Sun } from 'lucide-react';

import { language, setLanguage, t } from '@/shared/i18n';
import { useTheme } from '@/shared/lib/useTheme';
import { Button } from '@/shared/ui/Button';
import { TooltipProvider } from '@/shared/ui/Tooltip';

import { Backdrop } from './Backdrop';
import { Brand } from './Brand';
import styles from './PublicLayout.module.scss';

/**
 * Каркас открытых экранов: вход и приём приглашения — как во flow-do.
 *
 * Только знак, тема и язык. Боковое меню здесь было бы обещанием разделов,
 * по которым нельзя ходить. Язык — здесь же, а не только в меню человека:
 * до входа меню человека нет, а приглашённому англоязычному коллеге форму
 * надо прочитать уже сейчас.
 */
export function PublicLayout() {
  const { theme, toggle } = useTheme();

  return (
    <TooltipProvider delayDuration={400}>
      <div className={styles['layout']}>
        <Backdrop />
        <header className={styles['header']}>
          <Brand />
          <span className={styles['actions']}>
            <Button
              variant="ghost"
              tone="neutral"
              size="sm"
              aria-label={t.login.switchLanguage}
              onClick={() => {
                setLanguage(language === 'ru' ? 'en' : 'ru');
              }}
            >
              {language === 'ru' ? 'EN' : 'RU'}
            </Button>
            <Button
              iconOnly
              variant="ghost"
              tone="neutral"
              size="sm"
              onClick={toggle}
              aria-label={t.login.switchTheme}
            >
              {theme === 'dark' ? <Sun /> : <Moon />}
            </Button>
          </span>
        </header>
        <main className={styles['content']}>
          <Outlet />
        </main>
      </div>
    </TooltipProvider>
  );
}
